module.exports = __webpack_public_path__ + "static/media/IMG_8070 - Version 2.bfe21279.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/IMG_8070 - Version 2.jpg
// module id = 538
// module chunks = 0